// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__1X751","large":"large__2qhTc","disabled":"disabled__1G3B6","selected":"selected__2EAwF","outer":"outer__2nloh"};